import { FunctionComponent, useState } from 'react'
import { Section, SectionGroup } from '@/types/Section'
import { TableCell, TableRow } from '@mui/material'
import { Daycare } from '@/types/Daycare'
import Desktop from '@/modules/desktopMobile/desktop'
import { useTranslation } from 'react-i18next'
import EditIcon from '@mui/icons-material/Edit'
import { Delete } from '@mui/icons-material'
import styles from './sections.module.scss'
import ValidDeleteSectionDialog from './Dialog/validDeleteSectionDialog'
import SectionDialog from './Dialog/sectionDialog'

interface SectionsRowProps {
    section: Section
    canUpdate: boolean
    daycare: Daycare
    refetchSections: () => void
    sectionGroups: Array<SectionGroup>
}

const SectionsRow: FunctionComponent<SectionsRowProps> = ({
    section,
    canUpdate,
    daycare,
    refetchSections,
    sectionGroups
}: SectionsRowProps) => {
    const { t } = useTranslation()

    const [sectionName, setSectionName] = useState<string>(section.name || '')
    const [sectionMax, setSectionMax] = useState<string>(section.max.toString() || '')

    const [isDeleteSectionDialogOpen, setDeleteSectionDialogOpen] = useState<boolean>(false)
    const [isUpdateSectionDialogOpen, setUpdateSectionDialogOpen] = useState<boolean>(false)

    return (
        <>
            <TableRow>
                <TableCell>
                    <div className={styles.SectionNameContainer}> {sectionName} </div>
                </TableCell>
                <Desktop>
                    <TableCell> {sectionMax} </TableCell>
                    {daycare.staffAccess && (
                        <TableCell>
                            {section.sectionGroupId && sectionGroups
                                ? [...sectionGroups].find(
                                      (sg: SectionGroup): boolean => sg.id === section.sectionGroupId
                                  )?.name || t('noSectionGroup')
                                : t('noSectionGroup')}
                        </TableCell>
                    )}
                </Desktop>
                {canUpdate && (
                    <>
                        <TableCell>
                            <EditIcon className={styles.Icon} onClick={() => setUpdateSectionDialogOpen(true)} />
                        </TableCell>
                        <TableCell>
                            <Delete className={styles.Icon} onClick={() => setDeleteSectionDialogOpen(true)} />
                        </TableCell>
                    </>
                )}
            </TableRow>
            <SectionDialog
                open={isUpdateSectionDialogOpen}
                handleClose={() => setUpdateSectionDialogOpen(false)}
                daycare={daycare}
                create={false}
                sectionId={section.id}
                sectionName={sectionName}
                setSectionName={setSectionName}
                max={sectionMax}
                setMax={setSectionMax}
                sectionGroupId={section.sectionGroupId}
                refetchSections={refetchSections}
                sectionGroups={sectionGroups}
            />
            <ValidDeleteSectionDialog
                open={isDeleteSectionDialogOpen}
                handleClose={() => setDeleteSectionDialogOpen(false)}
                sectionId={section.id}
                daycareId={daycare.id}
                daycareType={daycare.type}
                refetchSections={refetchSections}
            />
        </>
    )
}

export default SectionsRow
